import { __assign } from 'tslib';
import { HTMLProjectionNode } from '../../projection/node/HTMLProjectionNode.js';
import { useEffect } from 'react';
import { isRefObject } from '../../utils/is-ref-object.js';

function useProjection(projectionId, _a, visualElement, initialPromotionConfig) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, onProjectionUpdate = _a.onProjectionUpdate;
    /**
     * Update latest options
     * TODO: Currently only updating onProjectionUpdate but this will be where
     * to add support for changing layoutId etc
     */
    useEffect(function () {
        if (!visualElement)
            return;
        var projection = visualElement.projection;
        if (!projection)
            return;
        projection.setOptions(__assign(__assign({}, projection.options), { onProjectionUpdate: onProjectionUpdate }));
    }, [visualElement, onProjectionUpdate]);
    if (!visualElement || (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection))
        return;
    visualElement.projection = new HTMLProjectionNode(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || (dragConstraints && isRefObject(dragConstraints)),
        visualElement: visualElement,
        scheduleRender: function () { return visualElement.scheduleRender(); },
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */
        animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
    });
}

export { useProjection };
